var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimpleHrActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.25 18.75C15.0825 18.75 19 14.8325 19 10C19 5.16751 15.0825 1.25 10.25 1.25C5.41751 1.25 1.5 5.16751 1.5 10C1.5 14.8325 5.41751 18.75 10.25 18.75Z",
    fill: "#2B5B7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 18.75C15.0825 18.75 19 14.8325 19 10C19 5.16751 15.0825 1.25 10.25 1.25C5.41751 1.25 1.5 5.16751 1.5 10C1.5 14.8325 5.41751 18.75 10.25 18.75Z",
    stroke: "white",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96875 9.26953C7.57281 9.26953 8.0625 8.77984 8.0625 8.17578C8.0625 7.57172 7.57281 7.08203 6.96875 7.08203C6.36469 7.08203 5.875 7.57172 5.875 8.17578C5.875 8.77984 6.36469 9.26953 6.96875 9.26953Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5312 9.26953C14.1353 9.26953 14.625 8.77984 14.625 8.17578C14.625 7.57172 14.1353 7.08203 13.5312 7.08203C12.9272 7.08203 12.4375 7.57172 12.4375 8.17578C12.4375 8.77984 12.9272 9.26953 13.5312 9.26953Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8957 12.1875C13.1392 13.4954 11.8695 14.375 10.2498 14.375C8.63018 14.375 7.36051 13.4954 6.604 12.1875",
    stroke: "white",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleHrActive);
export default __webpack_public_path__ + "static/media/SimpleHrActive.057ce65f9a3e925be9340ac59b4009c1.svg";
export { ForwardRef as ReactComponent };